import { OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

/** Filters out values that are falsey, with proper type inference */
export function filterFalsey<T, R extends NonNullable<T>>(): OperatorFunction<T, R> {
  return filter((a: T): a is R => !!a);
}
